import { render, staticRenderFns } from "./informationComparisonDialog.vue?vue&type=template&id=53550e38&scoped=true&"
import script from "./informationComparisonDialog.vue?vue&type=script&lang=js&"
export * from "./informationComparisonDialog.vue?vue&type=script&lang=js&"
import style0 from "./informationComparisonDialog.vue?vue&type=style&index=0&id=53550e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53550e38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53550e38')) {
      api.createRecord('53550e38', component.options)
    } else {
      api.reload('53550e38', component.options)
    }
    module.hot.accept("./informationComparisonDialog.vue?vue&type=template&id=53550e38&scoped=true&", function () {
      api.rerender('53550e38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/informationComparisonDialog.vue"
export default component.exports